<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Edit Terminal Batch Entries</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <EditTerminalBulkEntriesForm />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import EditTerminalBulkEntriesForm from "../../components/Kleyton/Forms/Terminal/EditTerminalBulkEntriesForm";

export default {
  page: {
    title: "Edit Batch Entries",
    meta: [{ name: "Edit Batch Entries", content: window.__env.app.description }]
  },

  components: {
    EditTerminalBulkEntriesForm,
    Layout,
    PageHeader
  },
  data() {
    return {
      name: "EditBatchEntries",
      title: "Edit Batch Entries",
      items: [
        {
          text: "Terminal Batch",
          href: "/"
        },
        {
          text: "Edit Terminal Batch Entries",
          active: true
        }
      ]
    };
  }
};
</script>

<style scoped></style>
